import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import InputText from '../InputText';
import Options from '../Options';
import { ButtonLike } from '../../theme/Options';
import Text from '../Text';
import { palette, breakpoints } from '../../../constants/styles';

const inputStyles = {
  width: '0px',
  outline: 'none',
  border: 'none',
  margin: '0',
  caretColor: 'transparent',
  transform: 'scale(0)',
};

const StyledSpan = styled.span`
  display: none;
  ${breakpoints.tabletLandscape} {
    font-size: 0.8em;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 20px;
    max-height: 15px;
    margin-right: 0.5em;
    background-color: ${palette.secondaryColorShy};
    padding: 5px;
    border-radius: 8px;
    border-color: ${palette.sweetGray};
    border: 1px solid;
    color: ${palette.sweetGray};
  }
`;

class YesNoQuestion extends Component {
  state = { answerIs: null };

  updateAnswer = (answerIs, answers = []) => this.setState({ answerIs, answers });

  render() {
    const {
      question,
      goal,
      form,
      onFocus,
      isFocused,
      onChange,
      onBlur,
      goToNextInput,
      injectNewQuestions,
      removeNewQuestions,
      handleFormAnswered,
      callOnItemSelected,
      importantKeyIsDown,
      importantKeyCallback,
    } = this.props;
    return (
      <Fragment>
        <Text type="body1">{question.startText}</Text>
        <InputText
          id={question.id}
          className={`question ${goal.value}`}
          autoFocus={question.index === 0 && goal.index === 0}
          name={question.inputName}
          onChange={ev => {
            console.log('ev');
            console.log(ev);
            form.handleChange(ev);
            form.setFieldTouched(question.inputName);
            form.validateForm(form.values);
            onChange(ev, { form, inputName: question.inputName });
          }}
          onFocus={ev => onFocus(ev, question.index, goal.value, form)}
          onBlur={ev => {
            form.handleBlur(ev);
            onBlur(ev, {
              values: form.values,
              goalName: goal.value,
              goalAnswered: goal.isAnswered,
              goalIndex: goal.index,
            });
          }}
          value={form.values[question.inputName]}
          style={inputStyles}
          autoComplete="off"
          positionAbsolute
          readOnly
        />
        <Options
          id={`${question.id}-2`}
          theme={ButtonLike}
          name={question.inputName}
          importantKeyIsDown={importantKeyIsDown}
          values={question.answers}
          callback={importantKeyCallback}
          renderItem={({ hotkey, label }) =>
            hotkey ? (
              <Fragment>
                <StyledSpan>{hotkey}</StyledSpan>
                {label}
              </Fragment>
            ) : (
              <Fragment>{label}</Fragment>
            )
          }
          onItemSelected={({ value, extraQuestions = [] }) => {
            callOnItemSelected();
            // First time user answers this question
            if (this.state.answerIs === null) {
              this.updateAnswer(value, extraQuestions);
              if (extraQuestions.length > 0) {
                injectNewQuestions(
                  extraQuestions,
                  goal.index,
                  question.index,
                  question.maxQuestions - extraQuestions.length,
                  () => {
                    form.values[question.inputName] = value;
                    handleFormAnswered(
                      {
                        values: form.values,
                        goalName: goal.value,
                        goalAnswered: goal.isAnswered,
                        goalIndex: goal.index,
                      },
                      () => {
                        goToNextInput(question.id);
                      },
                    );
                  },
                );
              } else {
                form.values[question.inputName] = value;
                // console.log('fv');
                handleFormAnswered(
                  {
                    values: form.values,
                    goalName: goal.value,
                    goalAnswered: goal.isAnswered,
                    goalIndex: goal.index,
                  },
                  () => {
                    goToNextInput(question.id);
                  },
                );
              }
            } else if (value !== this.state.answerIs) {
              if (!question.maxQuestions) {
                question.maxQuestions = 0;
              }
              removeNewQuestions(
                goal.index,
                question.index,
                -(question.maxQuestions - extraQuestions.length),
                () => {
                  this.updateAnswer(value, extraQuestions);
                  injectNewQuestions(
                    extraQuestions,
                    goal.index,
                    question.index,
                    question.maxQuestions - extraQuestions.length,
                    () => {
                      form.values[question.inputName] = value;
                      handleFormAnswered(
                        {
                          values: form.values,
                          goalName: goal.value,
                          goalAnswered: goal.isAnswered,
                          goalIndex: goal.index,
                        },
                        () => {
                          goToNextInput(question.id);
                        },
                      );
                    },
                  );
                },
              );
            }
          }}
          isFocused={isFocused}
          justValue
        />
      </Fragment>
    );
  }
}

YesNoQuestion.propTypes = {
  question: PropTypes.object,
  goal: PropTypes.object,
  form: PropTypes.object,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  goToNextInput: PropTypes.func,
  injectNewQuestions: PropTypes.func,
  removeNewQuestions: PropTypes.func,
  handleFormAnswered: PropTypes.func,
  callOnItemSelected: PropTypes.func,
  isFocused: PropTypes.bool,
  importantKeyIsDown: PropTypes.bool,
  importantKeyCallback: PropTypes.func,
};

YesNoQuestion.defaultProps = {
  question: {},
  goal: {},
  form: {},
  onFocus: () => {},
  onChange: () => {},
  onBlur: () => {},
  goToNextInput: () => {},
  injectNewQuestions: () => {},
  removeNewQuestions: () => {},
  handleFormAnswered: () => {},
  callOnItemSelected: () => {},
  isFocused: false,
  importantKeyIsDown: false,
  importantKeyCallback: () => {},
};

export default YesNoQuestion;
